import { useMemo } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { TimeZone } from "client/DateAndTime/timezones";
import { formatDate } from "client_legacy/ndaw/dateFormatting";
import { capitalizeFirstLetter } from "client/Misc/utils";
import { MaintenanceWindowAppModel } from "client/Api/TitleBar/GlobalSearch/globalSearch";

export function useTileTooltip(
	appIsNotAccessible: boolean,
	appIsLicensed: boolean
): string | undefined {
	return useMemo(
		(): string | undefined => {
			if (appIsNotAccessible || !appIsLicensed) {
				const tooltipKey: LocalizationKey = !appIsLicensed
					? "_AppIsInvisibleBecauseYouDontHaveTheRequiredPackage"
					: "_AppIsInvisibleBecauseYouDontHaveAccess";

				return localize(tooltipKey);
			}

			return undefined;
		},
		[appIsLicensed, appIsNotAccessible]
	);
}

export function generateMaintenanceMessage(
	objectKind: ObjectKind,
	maintenanceWindow: MaintenanceWindowAppModel,
	timezone: TimeZone
): string {
	const template: string = localize(
		objectKindToTemplateKey[objectKind]
	);

	const endDateString: string = formatDate(
		maintenanceWindow.endsOn,
		"DMYT",
		timezone
	);

	const detailedReason: string = maintenanceWindow.notificationMessage ?
		" " + capitalizeFirstLetter(maintenanceWindow.notificationMessage) + "."
		: "";

	return template.replace("{0}", endDateString) + detailedReason;
}

type ObjectKind = "app" | "space";

const objectKindToTemplateKey: Record<ObjectKind, LocalizationKey> = {
	["app"]: "_TheAppIsInMaintenanceUntil",
	["space"]: "_TheSpaceIsInMaintenanceUntil"
};
